import { useTranslation } from 'react-i18next';
import { RabbitRunningLightIcon } from '@c2fo/liquidity/icons';

const InstantPayIcon = () => {
  const { t } = useTranslation();

  return (
    <div
      aria-label={t('core.instantPay')}
      className="flex size-7 items-center justify-center rounded-full bg-teal-100 text-teal-900 [&>svg]:fill-teal-900"
      role="img"
    >
      <RabbitRunningLightIcon className="size-5" />
    </div>
  );
};

export default InstantPayIcon;
